import LandingPage from 'containers/Landing/LandingPage/Loadable';
import { pages } from '../constants';
import withContentful from '../withContenfull';

export default withContentful(pages.about)(LandingPage);
